"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ListingTile_styles_1 = require("./ListingTile.styles");
var ListingTile_classNames_1 = require("./ListingTile.classNames");
var Image_1 = require("office-ui-fabric-react/lib/components/Image");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var lib_1 = require("@uifabric/utilities/lib");
var ListingBookmarkButton_1 = require("./ListingBookmarkButton");
var ListingBookmarkListStore_1 = require("../model/ListingBookmarkListStore");
var ListingActions_1 = require("./ListingActions");
var ListingTile = /** @class */ (function (_super) {
    __extends(ListingTile, _super);
    function ListingTile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function () {
            _this.props.onClick(_this.props.listing);
        };
        return _this;
    }
    ListingTile.prototype._renderTop = function () {
        return (React.createElement("div", { className: lib_1.css(this._classNames.top, "opacity-hover") }));
    };
    ListingTile.prototype._renderThumbnail = function () {
        var listingLargeIcon = this.props.listing.large_icon;
        var thumbnail;
        var thumbnailIsIcon = false;
        if (listingLargeIcon && listingLargeIcon.url) {
            thumbnail = React.createElement(Image_1.Image, { width: 32, height: 32, src: listingLargeIcon.url, alt: this.props.listing.title });
        }
        else {
            thumbnailIsIcon = true;
            thumbnail = React.createElement(Icon_1.Icon, { iconName: "Puzzle", className: "thumnail-icon", title: this.props.listing.title });
        }
        return (React.createElement("div", { className: lib_1.css(this._classNames.thumbnail, { "is-icon": thumbnailIsIcon }) }, thumbnail));
    };
    ListingTile.prototype._renderTitle = function () {
        return (React.createElement("h3", { className: this._classNames.title }, this.props.listing.title));
    };
    ListingTile.prototype._renderShortDescription = function () {
        return (React.createElement("h5", { className: this._classNames.shortDescription }, this.props.listing.description_short));
    };
    ListingTile.prototype._renderContent = function () {
        return (React.createElement("div", { className: this._classNames.content },
            this._renderTitle(),
            this._renderShortDescription()));
    };
    ListingTile.prototype._renderFooter = function () {
        return (React.createElement("div", { className: this._classNames.footer },
            React.createElement(ListingBookmarkButton_1.ListingBookmarkButton, { bookmarkList: ListingBookmarkListStore_1.ListingBookmarkListStore, listingId: this.props.listing.id }),
            React.createElement(ListingActions_1.ListingLoadAction, __assign({}, this.props)),
            React.createElement(ListingActions_1.ListingOpenAction, __assign({}, this.props))));
    };
    ListingTile.prototype.render = function () {
        this._classNames = ListingTile_classNames_1.getClassNames(ListingTile_styles_1.getStyles(null, this.props.styles), this.props.className, this.props.onClick ? true : false);
        return (React.createElement("div", { className: this._classNames.root, role: this.props.onClick ? "button" : undefined, onClick: this.props.onClick ? this._onClick : undefined, title: this.props.listing.description_short },
            this._renderTop(),
            this._renderThumbnail(),
            this._renderContent(),
            this._renderFooter()));
    };
    return ListingTile;
}(React.Component));
exports.ListingTile = ListingTile;
